import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#HM_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HM_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HM_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HM_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HM_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#HM_svg__d)"
    }
  ))), /* @__PURE__ */ e.createElement("g", { clipPath: "url(#HM_svg__clip0_4799_265895)", fill: "#F7FCFF" }, /* @__PURE__ */ e.createElement("path", { d: "M9 20.5l-1.302 1.203.13-1.768-1.753-.267 1.463-1.002-.883-1.537 1.694.52L9 16l.65 1.648 1.695-.518-.883 1.536 1.463 1.002-1.752.267.129 1.768L9 20.5zM22 13l-.868.802.086-1.178-1.168-.179.975-.668-.589-1.024 1.13.346L22 10l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179L22 13zM24 5l-.868.802.086-1.179-1.168-.178.975-.668-.589-1.024 1.13.346L24 2l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179L24 5zM29 9l-.868.802.086-1.179-1.168-.178.975-.668-.589-1.024 1.13.346L29 6l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179L29 9zM25 22l-.868.802.086-1.178-1.168-.179.975-.668-.589-1.024 1.13.346L25 19l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179L25 22zM28.5 14.25l-.882.463.169-.981-.714-.695.986-.144L28.5 12l.44.893.987.143-.714.696.169.982-.882-.464z" }))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "HM_svg__clip0_4799_265895" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", transform: "translate(6 2)", d: "M0 0h25v21H0z" })))
);
export {
  t as default
};
